export const shopFragment = /* GraphQL */ `
  fragment shopData on Shop {
    id
    company
    slug
    about
    logo
    contacts
    enabled
    enableCart
    enablePayment
    enableEmailNotification
    enablePassword
    enableTax
    password
    hideFields
    website
    linkedin
    twitter
    facebook
    instagram
    partner
    accountID
    userID
    organizationID
    organization {
      id
      country
      isMaster
    }
    credentials
    createdAt
    placeID
    metadata {
      key
      type
      value
    }
    shareImage
    shareInfo
  }
`
